const h5Module = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {},
};

export default h5Module;
